module.exports = {
	"sv": {
		"conversation": {
			"widget": {
				"title": "Chatta med oss"
			}
		}
	}
};